import { EventStream } from "@iventis/utilities";

export enum RelayTimetableSplitEvent {
    LineSplit = "LineSplit",
}

/**
 * A line on the map replaced by its pieces: the pieces in order along the line, on the layer the line was on, and the
 * place the line held in the timetable, which the first piece takes. The place is left out when the map did not hold it
 * for the line, in which case the pieces take the place the timetable gives them. Sent once the pieces exist on the backend.
 */
export interface RelayTimetableSplitEventMessage {
    type: RelayTimetableSplitEvent.LineSplit;
    payload: { splitObjectIds: string[]; layerId: string; order: number | undefined };
}

/** How the map tells the relay timetable a line has been split, whether or not the timetable is open */
export const relayTimetableSplitEventStream = new EventStream<RelayTimetableSplitEventMessage>();
